<template>
  <div>
    <div>col</div>
  </div>
</template>
<script>
export default {
  name: 'baseCol'
}
</script>




// WEBPACK FOOTER //
// src/packages/col/base-col.vue